/*对方不是你好友通知*/
import {log} from '../../log.js'


var WxNotFriendNtf = function (ws, event, commandName, bodyStr, bodyObj) {
    log("server message received", commandName, bodyObj);
};
export default WxNotFriendNtf;